<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="buy-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title dialog-title"></h5>
                    <div class="buy-view">
                        <div class="exp-info">
                            <p>当前经验：<b>{{ exp_result() }}</b></p>
                            <p>可购经验：<b>{{ $store.state.userinfo.canBuy || 0 }}</b></p>
                        </div>

                        <div class="block">
                            <el-slider
                            v-model="value"
                            :min="0"
                            :max="$store.state.userinfo.canBuy"
                            :step="20"
                            >
                            </el-slider>

                            <div class="marks">
                                <div class="min">0</div>
                                <div class="max">{{ $store.state.userinfo.canBuy || 0 }}</div>
                            </div>

                            <div class="manual">
                                <span>输入数量</span>
                                <el-input-number
                                v-model="value" 
                                :min="0"
                                :max="$store.state.userinfo.canBuy"
                                :step=20
                                @input="number_fix()"
                                ></el-input-number>
                            </div>
                           
                        </div>

                    </div>

                    <div class="sum flex-center-center">
                        <div class="sum-exp">购买<em class="value">{{ value }}经验</em></div>
                        <div class="m3b">总消耗：<em class="value">{{ m3b_fix() }}梦三币</em><em class="icon"></em></div>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="call_buy()"></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>     
</template>

<style lang="scss" scoped>
.buy-modal{
    position: relative;
    // width: 662px;
    font-size: 24px;
    color: #3d3e43;
}

.title{
    width: 129px;
    height: 31px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-buy.png);    
}

.buy-view{
    width: 550px;
    margin: 0 auto;
    padding: 30px 0 0;
    line-height: 1.8;
    font-size: 24px;
    color: #5d2420;
    /* text-align: center; */
}

.exp-info{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.exp-info b{
    font-weight: 400;
    color: #5d2420;
}

.marks{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.buy-view .block{
    padding: 15px;
}

.u-ctrl .icon{
    display: inline-block;
    width: 31px;
    height: 30px;
    margin: 0 5px;
    /* background-image: url(~@/assets/images/icon-m3b.png); */
}

.u-ctrl{
    /* position: absolute;
    left: 50%;
    bottom: 58px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    // padding: 0 42px;
    box-sizing: border-box;
    /* transform: translateX(-50%); */
}

.u-ctrl .u-btn.cancel{
    width: 246px;
    height: 65px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

.u-ctrl .u-btn.ok{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 246px;
    height: 65px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-submit.png); 
}

.sum{
    font-size: 22px;
    font-weight: 700;
    color: #6d645a;
    text-align: center;
    // font-family: "HYJinKaiJ";

    .value{
        color: #e05b4a;
    }

    div{
        margin: 0 10px;
    }
}

.u-btn .m3b{
    position: relative;
    display: flex;
    align-items: center;
    height: 30px;
    /* font-size: 22px; */
    color: #fffffe;
    text-align: center;
    font-family: "HYJinKaiJ";
    transform: translateY(-1px);
}

.manual{
    display: flex;
    justify-content: center;
    width: 524px;
    margin: 0 auto;
    padding: 7px 0;
    border: 1px solid #f6d4c9;
    border-radius: 30px;
}

.manual span{
    padding-right: 20px;
    font-size: 22px;
    font-weight: 700;
    color: #6d645a;
}
</style>

<style>
.el-slider__runway{
    height: 10px;
    background-color: #e3c8a8;
    /* box-shadow: 0 0 3px 3px rgba(184, 122, 83, .5); */
}

.el-slider__bar{
    height: 8px;
    background: linear-gradient(to right, #ffa65f, #d75026);
}

.el-slider__button{
    width: 47px;
    height: 47px;
    border: none;
    background-image: url(~@/assets/images/modal/icon-circle.png);
    background-color: transparent;
}

.el-tooltip__popper.is-dark{
    font-size: 30px;
    color: transparent;
    font-weight: 700;
    background-color: transparent;
}

.el-tooltip__popper .popper__arrow{
    /* width: 12px;
    height: 21px;
    bottom: -10px;
    background-image: url(~@/assets/images/icon-arrow.png); 
    border: none; */
    display: none;
}

.el-tooltip__popper .popper__arrow::after{
    display: none;
}

.el-input{
    /* width: 345px; */
}

.el-input__inner{   
    background-color: transparent;
    border: none;
    font-size: 22px;
    color: #e05b4a;
}

.el-input-number__decrease, .el-input-number__increase{
    top: 6px;
    width: 31px;
    height: 31px;
    border: none;
}

.el-input-number__decrease i, .el-input-number__increase i{
    display: none;
}

.el-input-number__decrease{
    background: url(~@/assets/images/modal/btn-minus.png); 
}

.el-input-number__increase{
    background: url(~@/assets/images/modal/btn-plus.png); 
}

.el-tooltip__popper{
    /* padding-top: 20px; */
    transform: translateY(20px);
}
</style>

<script>
import {
    apiChickenBuy,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            gid : '1',
            giftName : '经验值',
            cost : 1,
            num : 1,
            score : 0,
            value : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        handleChange(value) {
            //console.log(value);
        },
        exp_result (){
            let vm = this;
            let max = 48000;
            return Math.min( (vm.$store.state.userinfo.buy +  vm.$store.state.userinfo.killScore) ,  max);
        },
        number_fix(){
            if(isNaN(this.value) || this.value < 0){
                this.value = 0;
            }
        },
        m3b_fix(){
            if(isNaN(this.value) || this.value < 0){
                return 0;
            }
            else{
                return Math.ceil(this.value/20);
            }           
        },                
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            if(!this.value)return this.$toast('请选择购买数量');

            apiChickenBuy({
                giftId : this.gid,
                num : this.value/20,
            }).then(
                res => {
                    this.destroyElement ();                
                    this.$msg_modal({text : '成功获得'+ this.value +'经验'});
                    
                    //this.$store.commit("$_setFinishRate", this.value  + (this.$store.state.account.buy  +  this.$store.state.account.killScore));
                    this.$store.commit("$_setExp", this.value );
                    this.$update_task();
                    
                    //TODO refresh

                    //this.$update_userType(10)
                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$msg_modal({text : rej.message , type : type});
                },                
            )

        },
        call_buy (){
            if(!this.value)return this.$toast('请选择购买数量');

            this.destroyElement (); 
            this.$comfirm_exp_modal({ cost : this.m3b_fix() });
        },        
    },    
}
</script>